export default __webpack_public_path__ + "images/mq-e82d6df9e99c87fb655bdcdc315d2730.svg";